import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { t } from "i18next"
import TableContainer from "components/Common/TableContainer"
import { Product } from "pages/admin/Products/Products"
import { ProductActionMenu } from "./Components/ProductActionMenu"
import { useTranslation } from "react-i18next"

interface ProductsTable {
  products: Product[]
  isAllChecked: boolean
  checkedProducts: Product[]
  toggleAllProducts: () => void
  toggleActiveProduct: (product: Product) => void
  togglecheckedProductHandler: (product: Product) => void
  editProductHandler: (product: Product) => void
  deleteProductHandler: (product: Product) => void
  viewDetailsHandler: (product: Product) => void
  addNewOffer: (product: Product) => void
  addNewCampaign: (product: Product) => void
  duplicateProductHandler: (product: Product) => void
  location?: any
}

const ProductsTable: React.FC<ProductsTable> = ({
  products,
  checkedProducts,
  isAllChecked,
  toggleActiveProduct,
  toggleAllProducts,
  togglecheckedProductHandler,
  editProductHandler,
  deleteProductHandler,
  viewDetailsHandler,
  addNewCampaign,
  addNewOffer,
  duplicateProductHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllProducts}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <input
              onClick={() =>
                togglecheckedProductHandler(cellProps.row.original)
              }
              checked={Boolean(
                checkedProducts.find(p => p.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("products_products"),
        accessor: "name",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <div className="d-flex justify-content-start align-items-center gap-3">
              <img
                src="https://placehold.co/30x30/png"
                alt="avatar"
                className="rounded-circle"
                style={{
                  width: "36px",
                  height: "36px",
                }}
              />
              <p className="mb-0">{cellProps.row.original.name}</p>
            </div>
          )
        },
      },
      {
        Header: t("products_category"),
        accessor: "category",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.category}</>
        },
      },
      {
        Header: t("products_couponBased"),
        accessor: "coupon",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <>
              {cellProps.row.original.couponBased ? (
                <span className="badge fw-semibold bg-primary-30 text-primary me-1 px-2 py-1 font-size-10">
                  {t("products_couponBased")}
                </span>
              ) : (
                <span className="badge fw-semibold bg-cyan-30 text-cyan me-1 px-2 py-1 font-size-10">
                  {t("products_oneTime")}
                </span>
              )}
            </>
          )
        },
      },
      {
        Header: t("common_price"),
        accessor: "price",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.price}</>
        },
      },
      {
        Header: t("common_size"),
        accessor: "size",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.size}</>
        },
      },
      {
        Header: t("products_stock"),
        accessor: "stock",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return <>{cellProps.row.original.stock}</>
        },
      },
      {
        Header: t("products_featured"),
        accessor: "featured",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <>
              {cellProps.row.original.featured ? (
                <span className="badge fw-semibold bg-success-30 text-success me-1 px-2 py-1 font-size-10">
                  {t("Featured")}
                </span>
              ) : (
                <></>
              )}
            </>
          )
        },
      },
      {
        Header: t("common_status"),
        accessor: "activeStatus",
        filterable: true,
        Cell: (cellProps: { row: { original: Product } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.status === "Active"}
                onClick={() => toggleActiveProduct(cellProps.row.original)}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.status}
              </label>
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Product } }) => {
          const order = cellProps.row.original
          return (
            <ProductActionMenu
              product={order}
              viewDetailsHandler={viewDetailsHandler}
              editProductHandler={editProductHandler}
              deleteProductHandler={deleteProductHandler}
              addNewOffer={addNewOffer}
              addNewCampaign={addNewCampaign}
              duplicateProductHandler={duplicateProductHandler}
            />
          )
        },
      },
    ],
    [products, t, checkedProducts]
  )

  return (
    <TableContainer
      columns={columns}
      data={products}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

ProductsTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProductsTable))
